<template>
  <div>
    <textarea :id="id" />
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
import "@/plugins/wysiwyg/ru.js";
import "tinymce/themes/modern/theme";
import "tinymce/skins/lightgray/skin.min.css";

import "@/plugins/wysiwyg/maxchars.js";

import "tinymce/plugins/advlist";
import "tinymce/plugins/autolink";
// import "tinymce/plugins/imagetools";
import "tinymce/plugins/link";
// import "tinymce/plugins/media";
import "tinymce/plugins/code";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/image";
import "tinymce/plugins/lists";
import "tinymce/plugins/preview";
import "tinymce/plugins/table";
import "tinymce/plugins/textcolor";
// import 'tinymce/plugins/wordcount'
// import 'tinymce/plugins/autosave'
// import 'tinymce/plugins/charmap'
// import 'tinymce/plugins/codesample'
// import 'tinymce/plugins/contextmenu'
// import 'tinymce/plugins/emoticons'
// import 'tinymce/plugins/fullscreen'
// import 'tinymce/plugins/hr'
// import 'tinymce/plugins/insertdatetime'
// import 'tinymce/plugins/noneditable'
import "tinymce/plugins/paste";
// import 'tinymce/plugins/print'
// import 'tinymce/plugins/searchreplace'
// import 'tinymce/plugins/tabfocus'
import "tinymce/plugins/template";
// import 'tinymce/plugins/textpattern'
// import 'tinymce/plugins/visualblocks'
// import 'tinymce/plugins/anchor'
// import 'tinymce/plugins/autoresize'
// import 'tinymce/plugins/bbcode'
// import 'tinymce/plugins/directionality'
// import 'tinymce/plugins/fullpage'
// import 'tinymce/plugins/help'
// import 'tinymce/plugins/importcss'
// import 'tinymce/plugins/legacyoutput'
// import 'tinymce/plugins/nonbreaking'
// import 'tinymce/plugins/pagebreak'
// import 'tinymce/plugins/save'
// import 'tinymce/plugins/spellchecker'
// import 'tinymce/plugins/toc'
// import 'tinymce/plugins/visualchars'

import defaultSettings from "@/settings";

const { baseApi } = defaultSettings;

export default {
  name: "Wysiwyg",
  props: {
    id: {
      type: String,
      default: () => {
        return `tinymce_${Math.random().toString(16).slice(2)}`;
      },
    },
    maxLength: {
      type: Number,
      default: 0,
    },
    value: {
      type: String,
      default: "",
    },
    height: {
      type: [Number, String],
      required: false,
      default: 250,
    },
    plugins: {
      type: Array,
      default: () => {
        return [
          "autolink lists link image preview",
          "code paste",
          "table",
          "textcolor colorpicker",
          "maxchars template",
        ];
      },
    },
    menubar: {
      type: String,
      default: "",
      // default: 'file edit insert view format table'
    },
    toolbar: {
      type: Array,
      default: () => [
        " undo redo formatselect bold italic underline strikethrough link image bullist numlist table alignleft aligncenter alignright preview template code",
      ],
    },
  },
  data() {
    return {
      content: "",
      checkerTimeout: null,
      isTyping: false,
      editor: null,
    };
  },
  watch: {
    value: function (newValue) {
      newValue = newValue || "";
      if (!this.isTyping) {
        if (this.editor !== null) {
          this.editor.setContent(newValue);
        } else {
          this.content = newValue;
        }
      }
    },
  },
  mounted() {
    this.content = this.value;
    this.init();
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  methods: {
    init() {
      const options = {
        selector: `#${this.id}`,
        skin: false,
        menubar: this.menubar,
        toolbar: this.toolbar,
        plugins: this.plugins,
        height: this.height,
        // оставляем стили доступные из редактора
        // стили font-family и т.п. отключаем
        valid_styles: {
          "*": "text-decoration text-align color background-color",
          img: "height",
        },
        setup: (editor) => {
          editor.maxChars = this.maxLength;

          // Добавляем CSS для редактора
          editor.on("init", () => {
            editor.dom.addStyle(`
              img { max-width: 100%; height: auto; }
            `);
          });

          // Обрабатываем изменения узлов (включая добавление изображений)
          editor.on("NodeChange", (e) => {
            // Проверяем, является ли измененный узел изображением с атрибутом width
            if (
              e.element &&
              e.element.tagName === "IMG" &&
              e.element?.attributes?.width?.value
            ) {
              const widthValue = parseInt(e.element.attributes.width.value);
              if (!isNaN(widthValue) && widthValue > 0) {
                const halfWidth = Math.round(widthValue / 2);
                e.element.setAttribute("data-width", halfWidth);
              }
            }
          });

          editor.on("OpenWindow", function () {
            setTimeout(() => {
              const input = document.querySelector(
                'input[type="file"][id$="-browse"]'
              );
              if (input) {
                input.accept = ".jpg,.jpeg,.png,.gif,.webp";
              }
            }, 50);
          });
        },
        init_instance_callback: this.initEditor,
        file_browser_callback_types: "image",
        file_browser_callback: function (field_name, url, type, win) {
          win.document.getElementById(field_name).value = url;
        },
        relative_urls: false,
        images_upload_handler: function (blobInfo, success, failure) {
          var xhr, formData;

          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open("POST", baseApi + "/api/admin/files/");

          xhr.onload = function () {
            var json;

            if (xhr.status != 200) {
              failure("HTTP Error: " + xhr.status);
              return;
            }

            json = JSON.parse(xhr.responseText);

            if (!json || typeof json.url != "string") {
              failure("Invalid JSON: " + xhr.responseText);
              return;
            }

            success(baseApi + json.url);
          };

          formData = new FormData();
          formData.append("file", blobInfo.blob(), blobInfo.filename());

          xhr.send(formData);
        },
        templates: [
          {
            title: "Ссылка-кнопка",
            content: `
              <a href="" target="_blank" rel="noopener noreferrer" class="link-button">Текст</a>
            `,
          },
          {
            title: "Блок со списком сотрудников",
            content: `
              <section>
                <article>
                  <img src="/static/180x180.svg" width="90" height="90" alt="" />
                  <div>Имя Фамилия</div>
                  <p>Должность</p>
                </article>
                <article>
                  <img src="/static/180x180.svg" width="90" height="90" alt="" />
                  <div>Имя Фамилия</div>
                  <p>Должность</p>
                </article>
                <article>
                  <img src="/static/180x180.svg" width="90" height="90" alt="" />
                  <div>Имя Фамилия</div>
                  <p>Должность</p>
                </article>
                <article>
                  <img src="/static/180x180.svg" width="90" height="90" alt="" />
                  <div>Имя Фамилия</div>
                  <p>Должность</p>
                </article>
                <article>
                  <img src="/static/180x180.svg" width="90" height="90" alt="" />
                  <div>Имя Фамилия</div>
                  <p>Должность</p>
                </article>
              </section>
            `,
          },
        ],
      };
      tinymce.init(options);
    },
    initEditor(editor) {
      this.editor = editor;
      editor.on("KeyUp", () => {
        this.getContent();
      });
      editor.on("Change", () => {
        if (this.editor.getContent() !== this.value) {
          this.getContent();
        }
      });

      editor.setContent(this.content);
      // this.$emit('input', this.content)
    },
    getContent() {
      this.isTyping = true;
      if (this.checkerTimeout !== null) clearTimeout(this.checkerTimeout);
      this.checkerTimeout = setTimeout(() => {
        this.isTyping = false;
      }, 300);
      this.$emit("input", this.editor.getContent());
    },
  },
};
</script>
